import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

export class SubmitRequestAnalytics extends BaseAnalytics {
    constructor(category = 'submit_request') {
        super();
        this.category = category;
    }

    requestConnectionSuccess() {
        this.send('request connection', 'success');
    }

    requestConnectionError(message: string, status?: number) {
        const label = status ? `error status: ${status} message ${message}` : `error ${message}`;
        this.send('request connection', label);
    }
}
